import { encrypt } from '@/common/securityUtils';

export const AddBankType = {
  Bank: '1',
  PostalBank: '2',
} as const;

export const AddBankInfoOptions = [
  {
    label: 'Other',
    value: encrypt(AddBankType.Bank),
  },
  {
    label: 'Post Bank',
    value: encrypt(AddBankType.PostalBank),
  },
];

export const AddBankFieldsConfig = [
  {
    key: AddBankType.Bank,
    bankInfo: [
      {
        name: 'bankName',
        label: 'paymentManagement.adminPaymentSetup.adminBankInfo.bankName',
        placeholder: 'Enter Bank Name',
        type: 'text',
      },
      {
        name: 'bankCode',
        label: 'paymentManagement.adminPaymentSetup.adminBankInfo.branchCode',
        placeholder: 'Enter Bank Code',
        type: 'number',
      },
      {
        name: 'branchName',
        label: 'paymentManagement.adminPaymentSetup.adminBankInfo.branchName',
        placeholder: 'Enter Branch Name',
        type: 'text',
      },
      {
        name: 'accountNumber',
        label: 'paymentManagement.adminPaymentSetup.adminBankInfo.accNum',
        placeholder: 'Enter Account Number',
        type: 'number',
      },
      {
        name: 'accountholderName',
        label: 'paymentManagement.adminPaymentSetup.adminBankInfo.accHolderName',
        placeholder: 'Enter Holder Name',
        type: 'text',
      },
    ],
  },
  {
    key: AddBankType.PostalBank,
    bankInfo: [
      {
        name: 'postalBankName',
        label: 'Bank Name',
        placeholder: 'Enter Bank Name',
        type: 'text',
      },
      {
        name: 'postalBankCode',
        label: 'Bank Code',
        placeholder: 'Enter Bank Code',
        type: 'number',
      },
      {
        name: 'AccountSymbol',
        label: 'Account Symbol',
        placeholder: 'Enter Account Symbol',
        type: 'number',
      },
      {
        name: 'postalAccountNumber',
        label: 'Account Number',
        placeholder: 'Enter Account Number',
        type: 'number',
      },
      {
        name: 'Account Holder Name',
        label: 'postalAccountHolderName',
        placeholder: 'Enter account Holder Name',
        type: 'text',
      },
    ],
  },
];
